import QRCode from 'qrcode'
import { colors } from 'shared/assets/styles'
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber'

export const getQrCode = async (code: string, color?: string) => {
    try {
        const qrCode = await QRCode.toDataURL(code, {
            type: 'image/webp',
            rendererOpts: {
                quality: 1
            },
            width: 800,
            height: 800,
            color: { dark: color ?? colors.black }
        })
        return qrCode
    } catch (error) {
        console.error('Error getting QR Code: ', error)
        return ''
    }
}

export const removeLocalitiesContainerFromDOM = () => {
    const localitiesContainers = document.querySelectorAll(
        '.localities-container'
    )
    localitiesContainers.forEach(localitiesContainer =>
        localitiesContainer.remove()
    )
}

export const marketSelect = <T>(choices: { reunion: T, france: T }): T => {
    type MarketName = 'reunion' | 'france'
    // $FlowFixMe
    const marketName: ?MarketName = process.env.REACT_APP_MARKET_NAME
    if (!marketName) {
        return choices.france
    }
    return choices[marketName]
}

const deviceWidth = window.outerWidth

export const IMAGE_SIZE = {
    SMALL: deviceWidth / 3,
    MEDIUM: deviceWidth / 2,
    LARGE: deviceWidth
}

export const resizeTwicpicsImage = (
    imageUrl?: string,
    width?: number = IMAGE_SIZE.MEDIUM
) => {
    if (!imageUrl) {
        return undefined
    }
    const maxWidth = Math.min(width, 1920)
    return `${imageUrl}?twic=v1/contain-max=${maxWidth}/output=webp`
}

export const validatePhoneNumber = (value: string) => {
    try {
        const phoneNumber = PhoneNumberUtil.getInstance().parse(value, 'FR')
        return PhoneNumberUtil.getInstance().isValidNumber(phoneNumber)
    } catch (e) {
        return false
    }
}

export const formatPhoneNumberToE164 = (value: string) => {
    try {
        const phoneNumber = PhoneNumberUtil.getInstance().parse(value, 'FR')
        console.log(
            value,
            PhoneNumberUtil.getInstance().format(
                phoneNumber,
                PhoneNumberFormat.E164
            )
        )
        return PhoneNumberUtil.getInstance().format(
            phoneNumber,
            PhoneNumberFormat.E164
        )
    } catch (e) {
        console.log(e)
        return value
    }
}
